import React from 'react'
import { Grid, Stack } from "@mui/material";
import TopSection from "../../../Components/Common/Top/TopSection";
import ProfitCenterConfiguration from './ProfitCenterConfiguration'

export const ProfitCenterConfigurationPage = () => {
  return (
<>
  <Stack>
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TopSection title="Profit Center Configuration" />
        <div className="container">
          <div><ProfitCenterConfiguration /></div>
        </div>
      </Grid>
    </Grid>
  </Stack>
</>
    
  )
}
